export default [
    { id: "Cloudformation", name: "Cloudformation", value: "cloudformation" },
    { id: "Terraform", name: "Terraform", value: "terraform" }
]